import { useState } from 'react'
import { ExpensesFilters, ExpensesListTable } from '../organism'
import {
  ExpensesReportFilterInput,
  OrderDirectionOption,
  PageSizeOption,
  useGetExpensesReportQuery,
} from '@/graphql/generated'
import { Pagination } from '../molecules'
import { useUserLanguage } from '@/customHooks'
import textsData from '@/textData/reportTexts.json'

const initialFilters: ExpensesReportFilterInput = {
  createdAtFrom: null,
  createdAtTo: null,
  categoryOption: null,
  orderDirection: OrderDirectionOption.Desc,
  pageSize: PageSizeOption.TwentyFive,
  page: null,
};

export const ExpensesReportPage = () => {
  const userLanguage = useUserLanguage()
  const texts = (userLanguage === 'es' ? textsData.es : textsData.en).expenseReport

  const [currentPage, setCurrentPage] = useState(1)
  const [filters, setFilters] = useState<ExpensesReportFilterInput>(initialFilters)

  const handleFilterChange = (newFilters: ExpensesReportFilterInput) => {
    setFilters(newFilters)
    setCurrentPage(1)
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    setFilters({ ...filters, page: page.toString() })
  }

  // Filtrar chargeStatus si existe (no está en ExpensesReportFilterInput)
  let cleanFilters: ExpensesReportFilterInput = { ...filters }
  if ('chargeStatus' in cleanFilters) {
    const { chargeStatus: _, ...filtersWithoutChargeStatus } = cleanFilters as any
    cleanFilters = filtersWithoutChargeStatus as ExpensesReportFilterInput
  }

  const { data } = useGetExpensesReportQuery({
    variables: {
      filterInput: { ...cleanFilters, page: currentPage.toString() },
    },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  })

  const currentDataCount = data?.expensesReport?.items?.length || 0
  const totalPages = data?.expensesReport?.pagination?.totalPages || 1
  const showPagination = currentDataCount > 0

  return (
    <>
      <div className="w-full px-4 md:px-6 space-y-6">
        <h2 className="text-xl md:text-2xl font-semibold">
          {texts.title}
        </h2>
        <div>
          <ExpensesFilters
            filters={filters}
            onFilterChange={handleFilterChange}
          />
        </div>
        <div className="overflow-x-auto">
          <ExpensesListTable
            filters={{ ...filters, page: currentPage.toString() }}
          />
        </div>
        {showPagination && (
          <div className="pt-2">
            <Pagination
              currentPage={currentPage}
              onPageChange={handlePageChange}
              currentDataCount={currentDataCount}
              pageSize={filters.pageSize || null}
              totalPages={totalPages}
            />
          </div>
        )}
      </div>
    </>
  )
}

